
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import ItemRoleRight from "./ItemRoleRight";
import { confirmAlert } from "react-confirm-alert";
import { RolesRight } from "../../configs";
import AlertErrorForm from "../../component/AlertErrorForm";
import AkkhorLayout from "../../layout/AkkhorLayout";

const _ = require("lodash")
export default function FormRolesPage() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [listRoleSetting, setListRoleSetting] = useState(RolesRight);
    const [localRole, setLocalRole] = useState(listRoleSetting);
    const [checkAllRole, setCheckAllRole] = useState(true);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            try {
                // 1. Load pipeline_settings trước
                const pipelineRes = await Axios.get(
                    URL_LIST_ALL + 'pipeline_settings?limit=1000',
                    user.config
                );

                if (pipelineRes.data.status !== 'success') {
                    console.error(pipelineRes.data.message);
                    return;
                }

                const listPipeLineSetting = pipelineRes.data.data;

                // 2. Tạo object quyền pipeline
                const pipelineRoles = {};
                Object.keys(listPipeLineSetting).forEach(key => {
                    const item = listPipeLineSetting[key];
                    pipelineRoles[item.alias] = {
                        title: item.title,
                        checked: false,
                        children: {
                            view: { checked: false, title:"Xem" },
                            move: { checked: false, title:"Chuyển trạng thái" },
                            action: { checked: false, title:"Thao tác" },
                        }
                    };
                });

                // 3. Merge với RolesRight mặc định
                let mergedRoles = {
                    ..._.cloneDeep(RolesRight),
                    ...pipelineRoles
                };

                // 4. Nếu đang edit, load role sau khi có pipeline
                if (id > 0) {
                    const roleRes = await Axios.get(
                        URL_LIST_ALL + 'roles/' + id,
                        user.config
                    );

                    if (roleRes.data.status === 'success') {
                        const detailData = roleRes.data.data;
                        if (mounted) {
                            setDetail(detailData);

                            let myrole = {};
                            try {
                                myrole = JSON.parse(detailData.roleright) || {};
                            } catch (e) {
                                console.error('Lỗi parse roleright', e);
                            }

                            mergedRoles = setRoleChecked(mergedRoles, myrole);
                        }
                    } else {
                        console.error(roleRes.data.message);
                    }
                }

                // 5. Cập nhật state cuối cùng
                if (mounted) {
                    setListRoleSetting(mergedRoles);
                    setLocalRole(mergedRoles);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();

        return () => {
            mounted = false;
        };
    }, [id, user.config, refresh]);



    const defaultdetail = { author_id: user.data.id, title: '', status: 1, roleright: null }


    const setRoleChecked = (mainRoles, role) => {
        let newDT = _.cloneDeep(mainRoles);

        Object.keys(newDT).forEach(key => {
            newDT[key].checked = role[key]?.checked || false;

            if (newDT[key].children) {
                Object.keys(newDT[key].children).forEach(key2 => {
                    newDT[key].children[key2].checked =
                        role[key]?.children?.[key2]?.checked || false;
                });
            }
        });

        return newDT;
    };


    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tiêu đề quyền hạn').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            values.roleright = JSON.stringify(localRole);
            setLoading(true)
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'roles/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật quyền thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {

                Axios.post(URL_LIST_ALL + 'roles', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới quyền thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const setCheckAll = () => {

        let newDT = Object.assign({}, RolesRight);
        Object.keys(newDT).map((key) => {
            let child1 = Object.assign({}, newDT[key]);
            child1.checked = checkAllRole;
            if (child1.children) {
                let children = Object.assign({}, child1.children);
                Object.keys(children).map((key2) => {
                    let child2 = Object.assign({}, children[key2]);
                    child2.checked = checkAllRole;
                    children[key2] = child2;
                    return key2;
                });
                child1.children = children;
            }
            newDT[key] = child1
            return key;
        });
        setLocalRole(newDT);
        setCheckAllRole(!checkAllRole)
    }
    return (
        <AkkhorLayout idrole="roles">
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Quyền hạn</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-6 col-12 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="Nhập tiêu đề" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-lg-6 col-12 form-group">
                                <label>Trạng thái</label>
                                <select className="form-control height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Khoá</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>
                            <div className="col-12 form-group">
                                <label>Chọn các chức năng cho quyền hạn<span className="text-danger">*</span></label>
                                <button type="button" className="btn btn-sm btn-info mb-2" onClick={setCheckAll}> {(checkAllRole ? 'Chọn' : 'Bỏ chọn') + ' tất cả'} </button>
                                <div className="row">
                                    {console.log(localRole)}
                                    {Object.keys(localRole).map((key, i) => <div className="col-12 col-sm-3 mb-3" key={i} ><div className="border p-3 shadow-sm h-100"><ItemRoleRight RolesRight={localRole[key]} name={key} parent={key} marginleft={1} dt={localRole} onChange={setLocalRole} /></div></div>)}
                                </div>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu quyền</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
